import React from 'react';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { CampaignAccessDTO } from '../../../../../../api/useCampaignAccessQuery';
import { IconButton } from '../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { Toggle } from '../../../../../../../CommonComponents/OPL/Toggle/Toggle';

interface Props {
  campaignAccess: CampaignAccessDTO;
  setCampaignAccess(campaignAccess: CampaignAccessDTO): void;
}

export const CampaignAccessTable: React.FC<Props> = ({ campaignAccess, setCampaignAccess }) => {
  const { relationships, canTransferOwnership } = campaignAccess;

  if (relationships && relationships.length === 0) {
    return null;
  }

  return (
    <HtmlTable variant="basic" my="16">
      <table>
        <colgroup>
          <col width="50%" />
          <col width="50%" />
        </colgroup>

        <thead>
          <tr>
            <th>
              <Text variant="smallCaps" textAlign="left">
                Name
              </Text>
            </th>
            <th>
              <Text variant="smallCaps" textAlign="left">
                Owner
              </Text>
            </th>

            <th aria-label="Actions for Table">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          {relationships.map(
            ({ firstName, lastName, isOwner, isRemovable, isManager, adviserId }) => (
              <tr key={adviserId}>
                <td>
                  <Text textAlign="left" fontWeight={500}>
                    {firstName} {lastName}
                  </Text>

                  {isManager && (
                    <Text textAlign="left" fontSize="small" color="neutral.600">
                      Manager
                    </Text>
                  )}
                </td>

                <td>
                  <Toggle
                    size="small"
                    checked={isOwner}
                    disabled={!canTransferOwnership}
                    onChange={evt => {
                      setCampaignAccess({
                        ...campaignAccess,
                        relationships: relationships.map(adviser => {
                          // We are assigning a new owner -> remove the ownership
                          // from the previous owner
                          if (evt.target.checked && adviser.isOwner) {
                            return {
                              ...adviser,
                              isOwner: false,
                            };
                          }

                          if (adviser.adviserId === adviserId) {
                            return {
                              ...adviser,
                              isOwner: evt.target.checked,
                            };
                          }

                          return adviser;
                        }),
                      });
                    }}
                    aria-label="Toggle campaign owner"
                  />
                </td>

                <td>
                  {isRemovable && (
                    <IconButton
                      variant="subtleInactive"
                      icon="far fa-trash-alt"
                      aria-label="Remove advisor"
                      onClick={() => {
                        setCampaignAccess({
                          ...campaignAccess,
                          relationships: relationships.filter(
                            adviser => adviser.adviserId !== adviserId,
                          ),
                        });
                      }}
                    />
                  )}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </HtmlTable>
  );
};
